export enum BadgeType {
  WARNING = 'warning',
  SUCCESS = 'success',
  FAIL = 'fail',
  INFO = 'info',
}
